/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { ScopeQuestionOptionalValue } from '@g17eco/types/survey';
import { QUESTION } from '@constants/terminology';
import { Column, Row } from '@g17eco/molecules/tracking-list';
import { getQuestionFullTitle } from '@utils/universalTracker';

interface RowEmptyProps {
  question: ScopeQuestionOptionalValue;
  rowIndex: number;
  alternativeCodes?: string[];
}

export const RowEmpty = (props: RowEmptyProps) => {
  const { question, rowIndex, alternativeCodes } = props;
  const title = getQuestionFullTitle(question.universalTracker, alternativeCodes);

  return (
    <Row key={`${question.universalTracker.getId()}-${rowIndex}`} className={'clickable'}>
      <Column className='pl-1' stretch truncate tooltip={`${QUESTION.CAPITALIZED_SINGULAR} not in scope`}>
        {title}
      </Column>
    </Row>
  );
}
